<div #el1 class="format-wrapper" (click)="move(el1)">
  <mat-card
    #el2
    class="p-2"
    (click)="selectFormat(format)"
    [ngClass]="{ disabled: format.childs?.length === 0 }"
  >
    <mat-icon color="primary" class="me-2">movie</mat-icon>

    <div>
      <div class="small font-weight-bold item-title">{{ format.title }}</div>

      <div class="d-flex">
        <div class="small item-description pe-3" *ngIf="producer$ | async">
          {{ 'list.formatContentId' | translate }} {{ format.contentFormatId }}
        </div>

        <div class="small item-description" *ngIf="format.childs?.length !== 0; else noResults">
          {{ 'list.episodeNumber' | translate }} {{ format.totalChildResults }}
        </div>

        <ng-template #noResults>
          <div class="small item-description">
            {{ 'list.noEpisodes' | translate }}
          </div>
        </ng-template>
      </div>
    </div>
  </mat-card>
</div>
